module.exports = __webpack_public_path__ + "img/registration success_SCN.46a2bc72.png";